module.exports = __webpack_public_path__ + "img/project9_2.png.34aeee82.webp";